import React, { useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import { formatContent } from "../../common";
export const BehaviourQuestions = ({
  result,
  loadingForBehaviourQuestions,
  handleOptionChange,
}) => {
  const formData = useSelector((state) => state.form);

  const bottomRef = useRef(null)

  const topscrl = useRef(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });

    if (!loadingForBehaviourQuestions) {
      topscrl.current?.scrollIntoView({ behavior: "smooth" });
    }

  }, [result, loadingForBehaviourQuestions])

  return (
    <div>
      <div ref={topscrl}></div>
      {
        !loadingForBehaviourQuestions && <div className="canLisTxtStyl">
          <p className="jb-3 " style={{ marginTop: '-12PX' }}>Answer following MCQs</p>
        </div>
      }

      {loadingForBehaviourQuestions ? (<>
        <div className="w-100 text-center">
          <p className='job_size'> Questions are generating. Please wait <Spinner animation="grow" size='sm' /> </p>
        </div>
        <div
          className="streamed-output"
          style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }}
          dangerouslySetInnerHTML={{ __html: formatContent(result) }}
        />
        {/* <div className="w-100 text-center">
          <ShimmerSimpleGallery card imageHeight={200} row={9} col={1} />

        </div> */}
      </>) :

        formData.behaviourQuestionsArray?.map((question, qIndex) => (
          <div key={qIndex} className="mb-2 border p-4 rounded-md shadow-sm rounded ">
            <p className="font-medium mb-1 job_size1 font-color-text fw-medium font-size-h3">
              {qIndex + 1}. {question.q}
            </p>

            <div className="space-y-2">
              {question.options.map((option, oIndex) => (
                <div key={oIndex}>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name={`question-${qIndex}`}
                      checked={
                        formData.answers[qIndex]?.option === option
                      }
                      onChange={() => {

                        handleOptionChange(
                          qIndex,
                          // option.behavior_code,
                          question.q,
                          option
                        )
                      }}
                      className="form-checkbox h-4 w-4 text-blue-600"
                    />
                    <span className="ms-2 job_size">{option}</span>
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}
      <div ref={bottomRef}></div>
    </div>
  );
};
